import { Translate } from 'next-translate';

export function formatPrice(
    price: number,
    currencyCode: string,
    t: Translate,
    locale: string,
    minimumFractionDigits: number,
    options?: { explicitZero?: boolean },
): string {
    if (price === 0 && !options?.explicitZero) {
        return t('Free');
    }

    const thousandsSeparatorRegex = new RegExp('\\B(?=(\\d{3})+(?!\\d))', 'g');

    return Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits,
    })
        .format(price)
        .replace(thousandsSeparatorRegex, '\u00A0');
}
